import type { SubscriptionDetails } from "schemas/generated/billing";

import * as React from "react";

import { billingRouter } from "@editor/trpc/billing";

import InlineAlert from "@replo/design-system/components/alert/InlineAlert";
import { skipToken } from "@tanstack/react-query";
import { format } from "date-fns";

const SubscriptonCancelledNotEndedAlert = ({
  activeSubscription,
  workspaceId,
  reploVersion,
}: {
  activeSubscription?: SubscriptionDetails;
  workspaceId: string;
  reploVersion: "v1" | "v2";
}) => {
  const { data: nextSubscriptionBillingDate } =
    billingRouter.getNextBillingDate.useQuery(
      workspaceId && activeSubscription?.id
        ? {
            workspaceId,
            subscriptionId: activeSubscription.id,
          }
        : skipToken,
    );

  const billingTierOfReploVersion =
    reploVersion === "v1"
      ? activeSubscription?.v1BillingTier
      : activeSubscription?.v2BillingTier;

  if (
    activeSubscription?.endedAt &&
    billingTierOfReploVersion !== "free" &&
    nextSubscriptionBillingDate
  ) {
    return (
      <InlineAlert variant="info">
        <p>
          You'll continue to have access to all features until{" "}
          <span className="inline font-bold">
            {nextSubscriptionBillingDate
              ? format(new Date(nextSubscriptionBillingDate), "MMMM d, yyyy")
              : "the end of your current billing period"}
          </span>
          . Your subscription will end after that, and you won't be charged
          again.
        </p>
      </InlineAlert>
    );
  }
};

export default SubscriptonCancelledNotEndedAlert;
